import { apiClient } from './client'
import endpoints from './endpoints'
import { unwrapSingle } from './normalize'

export async function addMonitoringEvent({
  farmId,
  isBackdatedEvent,
  eventData,
  eventStartDate,
  eventEndDate,
  gpsData,
  siteConfirmationRequired,
} = {}) {
  if (gpsData) {
    const formData = new FormData()
    formData.append('file', gpsData)
    formData.append('farmId', farmId)
    formData.append('eventData', JSON.stringify(eventData))
    formData.append('isBackdatedEvent', isBackdatedEvent)
    formData.append('eventStartDate', eventStartDate)
    formData.append('eventEndDate', eventEndDate)
    formData.append('siteConfirmationRequired', siteConfirmationRequired)
    const response = await apiClient.post(endpoints.v2.events, formData)
    return unwrapSingle(response)
  }

  const response = await apiClient.post(endpoints.v2.events, {
    farmId,
    eventData,
    eventStartDate,
    eventEndDate,
    isBackdatedEvent,
    siteConfirmationRequired,
  })
  return unwrapSingle(response)
}
